import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import * as moment from 'moment';

import { ISlimScrollOptions } from 'ng2-slimscroll';
import { MemberService } from './../member.service';
import { MessageEvent, SignInEvent, OpenFrameEvent, LoaderEvent, SidemenuSubCategory, HiddenFooter, SetAllMemberCheck } from './../../shared/message.event';
import { AppService } from '../../app.service'; // UnUsed
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { UtilityFunctions } from '../../shared/utility-functions';
import { BaseMember } from './../base-member';
@Component({
  selector: 'app-member-inactive',
  templateUrl: './member-inactive.component.html',
  styleUrls: ['./member-inactive.component.css'],
  providers: [MemberService, MessageEvent, SignInEvent, AppService, OpenFrameEvent, LoaderEvent, SidemenuSubCategory, HiddenFooter, SetAllMemberCheck]
})
export class MemberInactiveComponent extends BaseMember implements OnInit {

  private stringConstants = CONSTANT_MESSAGES;
  private shouldSlide: boolean = false;
  private hideEdit: boolean;
  private windowHeight = window.innerHeight;
  private topNav = 56;
  private midNav = 45;
  private footer = 35;
  private container = 20;
  private pagebutton = 20;
  private height: any;
  private divHeight = 30;
  private scrollOptions: ISlimScrollOptions;
  private selectMember;
  private filterFormember;
  private selectMamberFlag = false;
  private members = {
    'userIds': [],
    'vendorId': '',
    'duration': 0
  };
  private exp;
  private disableSelectMember = false;
  private enableButton = false;
  private noMemberAvailableInFilter = false;
  @ViewChild('memberTable')
  tableVariable: any;
  private totalSizeOfList = 0;
  private onePagePerItem = 10; // It will set by vendor configuration object
  private currentPage = 1;
  private currentFrame = 'ALL';
  private pageOptions = {
    currentPage: 1,
    noOfPageItem: this.onePagePerItem
  };

  private filterPara = 'ALL';
  private message = '';
  private memberTableHeight = 0;
  private changeTableSize = 50;
  private clubName = '';
  private setChecked = [];
  private showFilterGroup = false;
  private showFilterPreference = false;
  private selectItem = false;
  private userIdListFordisable = [];
  private filterSendInvite = false;
  private sendInviteFliterList = [{ name: 'Sent', status: true }, { name: 'Not Sent', status: false }];
  constructor(private router: Router, private memberService: MemberService, private appService: AppService,
    private openFrameEvent: OpenFrameEvent, private messageEvent: MessageEvent, private signInEvent: SignInEvent,
    private loaderEvent: LoaderEvent, private sidemenuSubCategory: SidemenuSubCategory, private hiddenFooter: HiddenFooter, private setAllMemberCheck: SetAllMemberCheck) {
    super();
    this.popUpMessage = 'Disable Members';
    this.hideEdit = false;
    this.scrollOptions = {
      barBackground: "#343a40", barOpacity: "0.6", position: "right",
      barWidth: "6", barBorderRadius: "5", barMargin: "1px 1px", gridBackground: "#adb5bd", gridOpacity: "1", gridWidth: "4", gridBorderRadius: "10", gridMargin: "1px 2px"
    };
    this.height = (this.windowHeight - (this.topNav + this.midNav + this.container + this.footer + this.divHeight
      + this.pagebutton)) + 'px';
    this.selectMember = false;
    this.exp = false;
  }

  ngOnInit() {
    let obj = {
      category: 'Inactive Members',
      menu: 'Inactive Members'
    };
    this.sidemenuSubCategory.fire(obj);
    this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
    if (this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
      if (this.vendor.subVendors.length > 0) {
        let subVendor = this.vendor.subVendors[0];
        this.clubName = subVendor.clubName;
      }
    } else {
      this.clubName = this.vendor.clubName;
    }
    this.currentFrame = 'ALL';
    this.pagination(this.pageOptions, 1, this.currentFrame);
    this.getFacilityListForMemberFilter(this);
    this.getGroupListForFilter(this);
    this.emitOpenFrameEvent();
    this.emitTypeBroadcast();
    this.registerTypeBroadcast();
  }

  /**
   * Temproray function
   */

  homeScreen() {
    this.utilityFunctions.homeScreen(this);
  }

  /**
   * Retrive MemberList with respect to condo
   */

  getMemberListByVendor(vendorObj) {
    try {
      let that = this;
      this.loaderEvent.fire(false);
      this.appService.getListOfMember(vendorObj).then((result: any) => {
        if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
          this.memberList = result.memberList;
          this.totalSizeOfList = result.total;
          this.memberList.map(function (mem) {
            if (!mem.isBlackListed) {
              mem.enable = 'Active';
            } else {
              mem.enable = 'Inactive';
            }
            mem.signedUpOn = that.utilityFunctions.maketimeZoneOfsetDate(mem.signedUpOn).format('DD/MM/YYYY');
            if (mem.hasLeftService) {
              mem.leftServiceDate = that.utilityFunctions.maketimeZoneOfsetDate(mem.leftServiceDate).format('DD/MM/YYYY');
            }
            return mem;
          });
          this.noMemberAvailable = this.memberList.length > 0;
          if (this.memberList.length > 0) {
            this.setCheckedList();
          }
        }
        if (vendorObj['filters'].length > 0) {
          this.noMemberAvailableInFilter = true;
        } else {
          this.noMemberAvailableInFilter = false;
        }
        this.loaderEvent.fire(true);
      })
        .catch((err) => {
          this.popUpMessage = err;
          this.loaderEvent.fire(true);
        });
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * TO change status of member if payment is done
   */

  onNotify(message: boolean): void {
    this.memberList.map(function (mem) {
      mem.isChecked = false;
      return mem;
    });
    this.reset();
  }

  emitTypeBroadcast() {
    let isShow = {
      privacypolicy: true,
      support: false,
      footer: 'block'
    };
    this.signInEvent.fire('block');
    this.hiddenFooter.fire(isShow);
  }

  emitOpenFrameEvent() {
    this.openFrameEvent.fire(false);
  }

  /**
   * while menu slide left to right as well as we shift header, footer and body too by broadcaster
   */

  registerTypeBroadcast() {
    this.messageEvent.on().subscribe(message => {
      this.shouldSlide = message;
    });
  }

  redirectToAllMember() {
    this.router.navigate(['/member']);
  }

  expand() {
    if ((this.searchMember + '').trim()) {
      if (this.currentFrame === 'ACTIVATE') {
        this.pagination(this.pageOptions, 1, 'ACTIVATE');
      } else if (this.currentFrame === 'DEACTIVATE') {
        this.pagination(this.pageOptions, 1, 'DEACTIVATE');
      } else {
        this.pagination(this.pageOptions, 1, 'ALL');
      }
    } else {
      if (this.exp) {
        this.pagination(this.pageOptions, 1, 'ALL');
      }
      this.exp = !this.exp;
    }
  }

  /**
   * Change activate or deactivate frame
   */
  redirectToInactiveMember(str) {
    try {
      this.selectMamberFlag = true;
      this.currentFrame = str;
      this.members.userIds = [];
      this.setChecked = [];
      this.memberTableHeight = this.changeTableSize;
      if (this.currentFrame == 'DEACTIVATE') {
        this.disableSelectMember = true;
      } else {
        this.disableSelectMember = false;
      }
      if (this.tableVariable.allInGroup) {
        this.tableVariable.allInGroup = false;
      }
    } catch (err) {
      console.log(err);
    }
  }

  /**
   * Make deactivate member
   */
  makeDeactivate(popUpObj, confirmPop) {
    try {
      if (this.members.userIds.length === 0) {
        this.popupTitle = 'Error';
        this.popUpMessage = CONSTANT_MESSAGES.SELECT_DEATCIVATE_MEMBER;
        popUpObj.showChildModal();
        return;
      } else {
        this.popupTitle = 'Deactivate Members';
        this.popUpMessage = CONSTANT_MESSAGES.DEATCIVATE_MULTIPLE_MEMBER;
        confirmPop.showChildModal(this.popupTitle, this.popUpMessage);
      }
    } catch (err) {
      console.log(err);
    }
  }
  /**
   * Insert member in list to activate or inactivate members
   */
  addMemberInList(memberObj: any) {
    if (memberObj.isChecked) {
      this.members.userIds.push(memberObj.userId);
      this.setChecked.push(memberObj.userId);
    } else {
      _.remove(this.members.userIds, function (n) {
        return n === memberObj.userId;
      });
      _.remove(this.setChecked, function (n) {
        return n === memberObj.userId;
      });
    }
    if (this.members.userIds.length === 0) {
      this.disableSelectMember = false;
      this.tableVariable.allInGroup = false;
    }
  }
  /**
   * Select all members to activate or inactivate
   */
  makeAllMemberSelected(memberList: any) {
    this.setChecked = this.setChecked.concat(memberList);
    this.setUserIdListFordisable();
    this.members.userIds = this.userIdListFordisable;
    this.disableSelectMember = true;
    if (!this.tableVariable.allInGroup) {
      this.disableSelectMember = false;
      this.members.userIds = [];
      this.setChecked = _.difference(this.setChecked, memberList);
    }
  }

  disableSelectMemberOnCheck(bool: boolean) {
    if (!this.disableSelectMember) {
      this.disableSelectMember = bool;
    }
  }

  /**
   * Show activate popup
   */
  makeActivate(popUpObj, confirmPop) {
    if (this.members.userIds.length > 0) {
      this.popUpMessage = CONSTANT_MESSAGES.ACTIVATE_MEMBER;
      confirmPop.showChildModal();
    } else {
      this.popUpMessage = CONSTANT_MESSAGES.SELECT_MEMBER_TO_ACTIVATE;
      popUpObj.showChildModal();
    }
  }

  /**
   * Make members activate
   */
  makeActive(event, popUpObj) {
    if (event) {
      let stayHere = 1;
      this.members.vendorId = this.vendor._id;
      this.memberService.markActiveToMember(this.members)
        .then((result: any) => {
          if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
            stayHere = 0;
          } else {
            stayHere = 1;
          }
          this.popUpMessage = result.message;
          popUpObj.showChildModal(stayHere);
        });
    }
  }
  /**
   * Make members inactivate
   */
  makeInactive(event, popUpObj) {
    if (event) {
      let stayHere = 1;
      let endDate;
      this.members.vendorId = this.vendor._id;
      let startDate = event.startDate.setHours(0, 0, 0, 0);
      startDate = new Date(startDate).toISOString();
      if (event.endDate) {
        endDate = event.endDate ? event.endDate.setHours(24, 0, 0, 0) : null;
        endDate = new Date(endDate).toISOString();
      }
      let userList = [];
      this.members.userIds.map(function (rec) {
        if (rec) {
          userList.push(rec);
        }
      });
      let reqObject = {
        userIds: userList,
        vendorId: this.vendor._id,
        //startTime: new Date(startDate).toJSON(),
        // endTime: endDate ? new Date(endDate).toJSON() : null,
        startTime: this.utilityFunctions.maketimeZoneOfsetDate(startDate, true),
        endTime: endDate ? this.utilityFunctions.maketimeZoneOfsetDate(endDate, true) : null,
        reason: event.reason
      };
      this.memberService.markDeactiveToMember(reqObject)
        .then((result: any) => {
          if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
            stayHere = 0;
            this.popupTitle = '';
          } else {
            stayHere = 1;
          }
          this.popUpMessage = result.message;
          popUpObj.showChildModal(stayHere);
        });
    }
  }
  /**
   * Reset whole page
   */
  reset() {
    this.disableSelectMember = false;
    this.selectMamberFlag = false;
    this.enableButton = false;
    this.currentFrame = 'ALL';
    this.members.userIds = [];
    this.memberTableHeight = 0;
    this.maintainFilterState();
    this.pagination(this.pageOptions, 1, this.currentFrame);
  }

  pagination(pageOptions, pageNo, currentFrame) {
    this.filterState = this.filterPara;
    if (pageOptions) {
      this.pageOptions = pageOptions;
    }
    let vendorObject = this.setVendorIdAsPerRole(this, pageNo);
    this.tableVariable.currentPage = pageNo ? pageNo : this.pageOptions.currentPage;
    vendorObject = this.setFilterAsPerFrame(vendorObject);
    this.message = CONSTANT_MESSAGES.NO_MEMBER_ADDED_MESSAGE;
    switch (this.filterPara) {
      case 'Inactive':
        vendorObject['filters'].push({
          type: 'isDeactivated',
          values: true
        });
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        break;
      case 'DisabledFacility':
        vendorObject['filters'].push({
          type: 'disabled',
          values: this.facilityFilter,
          applyAll: false
        });
        this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.facilityFilter));
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        break;
      case 'Prefernces':
        vendorObject['filters'].push({
          type: 'facilityPreference',
          values: this.preferenceFilter,
          applyAll: false
        });
        this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.preferenceFilter));
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        break;
      case 'Groups':
        vendorObject['filters'].push({
          type: 'group',
          values: this.groupFilter,
          applyAll: false
        });
        this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.groupFilter));
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        break;
      case 'ActivePage':
        vendorObject['filters'].push({
          type: 'isDeactivated',
          values: true
        });
        this.filterPara = '';
        break;
      case 'SentInvite':
        if (this.inviteStatusFilter.indexOf(true) >= 0 && this.inviteStatusFilter.indexOf(false) < 0) {
          vendorObject['filters'].push({
            type: 'isInviteSent',
            values: true
          });
        }
        if (this.inviteStatusFilter.indexOf(false) >= 0 && this.inviteStatusFilter.indexOf(true) < 0) {
          vendorObject['filters'].push({
            type: 'isInviteSent',
            values: false
          });
        }
        if (this.inviteStatusFilter.length == 0) {
          vendorObject['filters'] = [];
        }
        this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.inviteStatusFilter));
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        break;
    }
    if ((this.searchMember + '').trim()) {
      vendorObject['filters'].push({
        type: 'search',
        values: this.searchMember
      });
      this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
    }
    this.getMemberListByVendor(vendorObject);
  }
  /**
       * Add facility in list to filter by disable facility
       */
  addFacilityForFilter(e, facilityId) {
    this.utilityFunctions.addFacilityForFilter(this, e, facilityId);
  }
  /**
       * Add group in list to filter by group
       */
  addGroupForFilter(e, groupId) {
    this.utilityFunctions.addGroupForFilter(this, e, groupId);
  }
  /**
       * Add facility in list to filter by preference
       */
  addPreferencesForFilter(e, facilityId) {
    this.utilityFunctions.addPreferencesForFilter(this, e, facilityId);
  }
  /**
       * Select filter criteria
       */
  addInviteStatusForFilter(e, status) {
    this.utilityFunctions.addInviteStatusForFilter(this, e, status);
  }
  setFilterCriteria(para) {
    this.utilityFunctions.setFilterCriteria(this, para);
  }
  /**
       * Store selected list
       */
  setCheckedList() {
    try {
      let flagAllchecked = true;
      for (let rec of this.setChecked) {
        for (let mem of this.memberList) {
          if (rec === mem.userId) {
            mem.isChecked = true;
            break;
          }
        }
      }
      for (let mem of this.memberList) {
        if (!mem.isChecked) {
          flagAllchecked = false;
          break;
        }
      }
      if (flagAllchecked) {
        this.tableVariable.allInGroup = true;
      } else {
        this.tableVariable.allInGroup = false;
      }
    } catch (e) {
      console.log(e);
    }
  }

  /**
       * Maintain filter state
       */
  maintainFilterState() {
    this.utilityFunctions.maintainFilterState(this);
  }
  /**
   * Set filter to ALL category
   *
   *
   * @memberof MemberInactiveComponent
   */
  setAllUncheck() {
    if (this.facilityFilter.length == 0 && this.preferenceFilter.length == 0 && this.groupFilter.length == 0) {
      this.filterPara = 'ALL';
      this.filterState = 'ALL';

      this.setFilterCriteria('ALL');
    }
  }

  setUserIdListFordisable() {
    for (let rec of this.setChecked) {
      for (let mem of this.memberList) {
        if (rec === mem.userId) {
          this.userIdListFordisable.push(mem.userId);
        }
      }
    }
  }

  setFilterAsPerFrame(vendorObject) {
    if ((this.currentFrame === 'ALL' || this.currentFrame === 'ACTIVATE')) {
      vendorObject['filters'].push({
        type: 'isDeactivated',
        values: true
      });
    } else if (this.currentFrame === 'DEACTIVATE') {
      vendorObject['filters'].push({
        type: 'isDeactivated',
        values: false
      });
    };

    return vendorObject;
  }
}



// WEBPACK FOOTER //
// ./src/app/member/member-inactive/member-inactive.component.ts